// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"b2bdc65d","528":"0d77e093","529":"f6bdc687","709":"e99a7c58","819":"9bc86ed3","913":"0a321563"}[chunkId] + ".chunk.css";
};